import { getDefaultTexts } from "../utils/getDefaultTexts.js";
function getDefaultCardState(props) {
  const active = props?.active ?? false;
  const size = props?.size ?? "small";
  const texts = getDefaultTexts(props?.texts);
  return { active, size, texts };
}
export {
  getDefaultCardState
};
//# sourceMappingURL=defaultCardState.js.map
